var map = {
	"./1eq.jpg": 161,
	"./IEEE.png": 162,
	"./USC_logo.png": 163,
	"./USC_thumbnail.png": 164,
	"./address_image.svg": 165,
	"./android-chrome-192x192.png": 166,
	"./android-chrome-512x512.png": 167,
	"./animated_logo.svg": 168,
	"./apple-touch-icon.png": 169,
	"./blogs_image.svg": 170,
	"./camera.png": 171,
	"./cloud_infrastructure.svg": 172,
	"./codeInLogo.png": 173,
	"./contactMail.png": 174,
	"./coursera_logo.png": 175,
	"./csgo.png": 176,
	"./data_science.svg": 177,
	"./deeplearning_ai_logo.png": 178,
	"./delhivery_logo.png": 179,
	"./developerActivity.svg": 180,
	"./dsc_logo.png": 181,
	"./duke.jpg": 182,
	"./education.svg": 183,
	"./experience.svg": 184,
	"./favicon-16x16.png": 185,
	"./favicon-32x32.png": 186,
	"./favicon.ico": 187,
	"./feelingProud.svg": 188,
	"./freecopy_logo.png": 189,
	"./fullstack.svg": 190,
	"./gcp_logo.png": 191,
	"./github_logo.png": 192,
	"./googleAssistant.jpg": 193,
	"./googleAssistant.svg": 194,
	"./google_logo.png": 195,
	"./ibm_logo.png": 196,
	"./iiitk_logo.png": 197,
	"./intel_logo.jpg": 198,
	"./jsFramework.svg": 199,
	"./legato_logo.png": 200,
	"./manOnTable.svg": 201,
	"./microsoft_logo.png": 202,
	"./motorcycle.png": 203,
	"./mozilla_logo.png": 204,
	"./muffito_logo.png": 205,
	"./mym.jpg": 206,
	"./mym.png": 207,
	"./nextuLogo.jpg": 208,
	"./nptel_logo.png": 209,
	"./pict_logo.png": 210,
	"./pictoreal_logo.png": 211,
	"./portfolio.gif": 212,
	"./pp.png": 213,
	"./profile-removebg-preview.png": 214,
	"./profile.JPG": 215,
	"./programmer.svg": 216,
	"./projects_image.svg": 217,
	"./pwa.png": 218,
	"./rhythm.png": 219,
	"./saayaHealthLogo.png": 220,
	"./site.webmanifest": 221,
	"./stanford_logo.png": 222,
	"./swimming.jpg": 223,
	"./talksCardBack.svg": 224,
	"./talksCardBackAlt.svg": 225,
	"./thkuosat.png": 226,
	"./ui_ux_design.svg": 227,
	"./usc_logo_2.png": 228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72;